import type { BaseController } from '@infra/controllers/base.controller';
import type { BusUserAvailabilityChangedPayload } from '@main/event-listeners/payloads/bus-user-availability-changed.payload';
import type { StatusSyncAircallToCrmUsecase } from '@usecases/status-sync-aircall-to-crm.usecase';

export type StatusSyncAircallToCrmInput = BusUserAvailabilityChangedPayload;

export type StatusSyncAircallToCrmOutput = void;

export class StatusSyncAircallToCrmController
  implements
    BaseController<StatusSyncAircallToCrmInput, StatusSyncAircallToCrmOutput>
{
  constructor(private usecase: StatusSyncAircallToCrmUsecase) {}

  async handle(
    req: StatusSyncAircallToCrmInput,
  ): Promise<StatusSyncAircallToCrmOutput> {
    // const agentStatus: AgentStatus =
    //   req.status === 'available'
    //     ? AgentStatus.AVAILABLE
    //     : req.status === 'offline' || status === 'do_not_disturb'
    //     ? AgentStatus.UNAVAILABLE
    //     : AgentStatus.OTHER;

    await this.usecase.run(req);
  }
}
